import { FormFieldConfig } from '@shared/components/search-form/search-form.component';
import { TableColumn } from '@shared/components/data-table/data-table.component';

// ============================================================================
// SEARCH FORM CONFIGURATIONS
// ============================================================================

export const BATCH_SEARCH_CONFIG: FormFieldConfig[] = [
  {
    key: 'skuCode',
    label: 'batch_management.search_filter.sku_name',
    type: 'searchableDropdown',
    placeholder: 'batch_management.search_filter.select_sku',
    width: '300px',
    showClear: true,
    options: [], // Will be populated dynamically
  },
  {
    key: 'warehouseId',
    label: 'batch_management.search_filter.warehouse_name',
    type: 'select',
    placeholder: 'batch_management.search_filter.select_warehouse',
    options: [], // Will be populated dynamically
    showClear: true,
    width: '300px',
  },
  {
    key: 'status',
    label: 'batch_management.search_filter.status',
    type: 'select',
    placeholder: 'batch_management.search_filter.select_status',
    options: [
      { label: 'batch_management.status.active', value: 'ACTIVE' },
      { label: 'batch_management.status.inactive', value: 'INACTIVE' },
      { label: 'batch_management.status.expired', value: 'EXPIRED' },
    ],
    showClear: true,
    width: '200px',
  },
];

// ============================================================================
// TABLE COLUMN CONFIGURATIONS
// ============================================================================

/**
 * Default column property names for Batch table
 */
export const BATCH_DEFAULT_COLUMNS = {
  BATCH_ID: 'batchId',
  SKU_NAME: 'skuName',
  MANUFACTURE_DATE: 'manufactureDate',
  EXPIRY_DATE: 'expiryDate',
  WAREHOUSE_NAME: 'warehouseName',
  STATUS: 'status',
  QTY: 'qty',
} as const;

/**
 * Flexible column property names for Batch table
 */
export const BATCH_FLEXIBLE_COLUMNS = {
  SKU_CODE: 'skuCode',
} as const;

/**
 * Default columns order for Batch table
 */
export const BATCH_DEFAULT_COLUMNS_ORDER: string[] = [
  BATCH_DEFAULT_COLUMNS.BATCH_ID,
  BATCH_DEFAULT_COLUMNS.SKU_NAME,
  BATCH_DEFAULT_COLUMNS.MANUFACTURE_DATE,
  BATCH_DEFAULT_COLUMNS.EXPIRY_DATE,
  BATCH_DEFAULT_COLUMNS.WAREHOUSE_NAME,
  BATCH_DEFAULT_COLUMNS.STATUS,
  BATCH_DEFAULT_COLUMNS.QTY,
];

/**
 * Flexible columns array for Batch table
 */
export const BATCH_FLEXIBLE_COLUMNS_ORDER: string[] = [
  BATCH_FLEXIBLE_COLUMNS.SKU_CODE,
];

export const BATCH_TABLE_CONFIG: TableColumn[] = [
  {
    label: 'batch_management.table.columns.batch_id',
    prop: BATCH_DEFAULT_COLUMNS.BATCH_ID,
    width: 160,
  },
  {
    label: 'batch_management.table.columns.item_name',
    prop: BATCH_DEFAULT_COLUMNS.SKU_NAME,
    width: 200,
  },
  {
    label: 'batch_management.table.columns.manufacture_date',
    prop: BATCH_DEFAULT_COLUMNS.MANUFACTURE_DATE,
    width: 140,
    type: 'custom',
  },
  {
    label: 'batch_management.table.columns.expiry_date',
    prop: BATCH_DEFAULT_COLUMNS.EXPIRY_DATE,
    width: 140,
    type: 'custom',
  },
  {
    label: 'batch_management.table.columns.warehouse_name',
    prop: BATCH_DEFAULT_COLUMNS.WAREHOUSE_NAME,
    width: 140,
    type: 'text',
  },
  {
    label: 'batch_management.table.columns.status',
    prop: BATCH_DEFAULT_COLUMNS.STATUS,
    width: 120,
    type: 'status',
  },
  {
    label: 'batch_management.table.columns.batch_quantity',
    prop: BATCH_DEFAULT_COLUMNS.QTY,
    width: 140,
    type: 'custom',
    styleClass: 'text-right',
  },
  {
    label: 'batch_management.table.columns.sku_code',
    prop: BATCH_FLEXIBLE_COLUMNS.SKU_CODE,
    width: 150,
  },
];

// ============================================================================
// CONSTANTS
// ============================================================================

export const BATCH_DEFAULT_CONFIG = {
  PAGE_SIZE: 20,
} as const;

